const SPARKS = [
  [4, 18, -3.1], [96, 28, -0.8], [6, 52, -4.5], [94, 76, -2.2],
  [10, 88, -1.6], [91, 44, -3.7], [18, 12, -0.2], [82, 15, -2.8],
];

// Texture fragments come from the user's reference; every label remains live HTML.
export const LegendaryPower = () => (
  <>
    <div className="legendary-electricity" aria-hidden="true" data-testid="roadmap-10m-electricity">
      {["left", "right"].map((side) => (
        <svg key={side} className={`legendary-electricity__rail legendary-electricity__rail--${side}`}
          viewBox="0 0 24 600" preserveAspectRatio="none" focusable="false">
          <path className="legendary-electricity__trace" d="M12 0 L7 52 L14 79 L8 143 L16 192 L6 224 L12 303 L5 357 L15 409 L7 463 L14 509 L9 600" pathLength="100" />
          <path className="legendary-electricity__current" d="M12 0 L7 52 L14 79 L8 143 L16 192 L6 224 L12 303 L5 357 L15 409 L7 463 L14 509 L9 600" pathLength="100" />
        </svg>
      ))}
      {SPARKS.map(([left, top, delay], i) => (
        <span key={i} className="legendary-spark" style={{ left: `${left}%`, top: `${top}%`, animationDelay: `${delay}s` }} />
      ))}
    </div>
    <div className="legendary-pedestal" aria-hidden="true" data-testid="roadmap-10m-pedestal">
      <span className="legendary-pedestal__projection" />
      <img src="/assets/artwork/legendary/power-pedestal.webp" alt="" width="504" height="100" loading="lazy" decoding="async" />
      <svg viewBox="0 0 400 80" className="legendary-pedestal__orbit" focusable="false">
        <ellipse cx="200" cy="38" rx="119" ry="18" pathLength="100" />
        <ellipse cx="200" cy="38" rx="74" ry="10" pathLength="100" />
      </svg>
    </div>
  </>
);